<template lang="pug">
  bar-slider(:value="value" :interval="interval"  :label-values="labelValues" :valid-values="validValues" :min="min" :max="max" @change="onChangeSlider")
</template>

<script>
import { BarSlider } from '@/thirdparty/BarSlider';

export default {
  name: 'nSliderVRNET',
  components: {
    BarSlider
  },
  props: {
    interval: Number,
    min: Number,
    max: Number,
    value: Number,
    labelValues: Array,
    validValues: Array
  },
  methods: {
    onChangeSlider(value) {
      this.$emit('change', parseInt(value, 10));
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/n-slider-vrnet.vue